// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","inner":"Footer_inner__fhIqU","logo":"Footer_logo__GkEml","links":"Footer_links__q2x7d","link":"Footer_link__MsGIJ","copy":"Footer_copy__nbk1i"};